import React, { useEffect } from "react";
import { useFetch } from "../hooks";
import { useDispatch, useSelector } from "react-redux";
import { setUser } from "../slices/employSlice";
import { useNavigate, useLocation } from "react-router-dom";
import { Loader } from "./";
import runOneSignal from "../onesignal/config";

const GetCurrenUser = ({ children }) => {
  const dispatch = useDispatch();
  const pathname = useLocation();
  const navigate = useNavigate();
  const navigateTo = pathname !== ("/login" || "/register") ? pathname : "/";

  const { isFetching } = useFetch(`/user/info`, {
    onSuccess: (res) => {
      dispatch(setUser({ ...res.data?.data[0], authenticated: true }));
      navigate(navigateTo);
    },
  });
  // const user = useSelector((state) => state.user);

  // useEffect(() => {
  //   runOneSignal(user?.id);
  // }, [user?.id]);

  if (isFetching) {
    return <Loader />;
  }

  return <>{children}</>;
};

export default GetCurrenUser;
